// ADD ACTION TYPES FOR EACH USED REPOSITORY
import * as actionTypes from '../Actions/actionTypes';

// Application State
const initialState = {
    appTitle:"My Re-insurance APP",
    sidebarShow:true,
    log:[],
    user:{arcs:0,fullName:"",login:"",sessionId:""},
    isPageLoading:false,
}


// METHOD
// LOGS
const getLogs = (state)=>{
    console.log(state.log);
}

// LOGIN
const logUser = (state,action)=>{
    console.log("LOG USER",action);
    var stateTmp = {...state};
    stateTmp.user = action.data;
    // LOGS
    stateTmp.log.push({key:"logUser",value:action});
    return stateTmp;
}
const cleanUser = (state,action)=>{
    var stateTmp = {...state};
    stateTmp.user = {arcs:0,fullName:"",login:"",sessionId:""};
    localStorage.removeItem('Reassurance.session.arcs');
    localStorage.removeItem('Reassurance.session.fullname');
    localStorage.removeItem('Reassurance.session.login');
    localStorage.removeItem('Reassurance.session.sessionId');
    localStorage.removeItem('Reassurance.session.session');
    localStorage.removeItem('Reassurance.session.user');
    // LOGS
    stateTmp.log.push({key:"cleanUser",value:stateTmp.user});
    return stateTmp;
}



// INTERFACE
const toggleSidebar = (state) =>{
    var stateTmp = {...state};
    stateTmp.sidebarShow = !stateTmp.sidebarShow;
    // LOGS
    stateTmp.log.push({key:"toggleSidebar",value:stateTmp.sidebarShow});
    return stateTmp;
}
const pageLoad = (state)=>{
    var stateTmp = {...state};
    stateTmp.isPageLoading = true;
    return stateTmp;
}
const pageLoaded = (state)=>{
    var stateTmp = {...state};
    stateTmp.isPageLoading = false;
    return stateTmp;
}



//SWITCH
const globalReducer = (state = initialState, action) => {

    switch (action.type) {
        case actionTypes.DISPLAY_APP_LOG:
            return getLogs(state,action);
        case actionTypes.LOG_USER:
            return logUser(state,action);
        case actionTypes.DISCONNECT:
            return cleanUser(state,action);
        case actionTypes.TOGGLE_SIDEBAR:
            return toggleSidebar(state,action);
        case actionTypes.PAGE_LOADING:
            return pageLoad(state,action);
        case actionTypes.PAGE_LOADED:
            return pageLoaded(state,action);
        default:
            return { ...state}
    }
}
export default globalReducer;